import React from "react";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function LanguageSection({ form, setForm }) {
  const handleChange = (index, field, value) => {
    const updated = [...form.language_skills];
    updated[index][field] = value;
    setForm({ ...form, language_skills: updated });
  };

  const handleAdd = () => {
    setForm({
      ...form,
      language_skills: [
        ...form.language_skills,
        { language: "", proficiency: "" },
      ],
    });
  };

  const handleRemove = (index) => {
    const updated = form.language_skills.filter((_, i) => i !== index);
    setForm({ ...form, language_skills: updated });
  };

  return (
    <Box className="candidate-section">
      <Box className="candidate-section-head">
        <Typography className="candidate-section-kicker">Section 4</Typography>
        <Typography className="candidate-section-title">Language Skills</Typography>
        <Typography className="candidate-section-subtitle">
          Record spoken and written proficiency for role matching.
        </Typography>
      </Box>

      {form.language_skills.length === 0 ? (
        <Box className="candidate-empty-state">
          <Typography>No language skills added yet.</Typography>
        </Box>
      ) : null}

      {form.language_skills.map((lang, index) => (
        <Box key={index} className="candidate-entry-card">
          <Box className="candidate-entry-top">
            <Typography className="candidate-entry-title">
              Language {index + 1}
            </Typography>
            <IconButton
              type="button"
              onClick={() => handleRemove(index)}
              className="candidate-remove-btn"
            >
              <DeleteIcon />
            </IconButton>
          </Box>

          <Box className="candidate-grid two-col">
            <TextField
              fullWidth
              label="Language"
              value={lang.language}
              onChange={(e) => handleChange(index, "language", e.target.value)}
            />

            <TextField
              fullWidth
              select
              label="Proficiency"
              value={lang.proficiency}
              onChange={(e) =>
                handleChange(index, "proficiency", e.target.value)
              }
            >
              <MenuItem value="">Select</MenuItem>
              <MenuItem value="Beginner">Beginner</MenuItem>
              <MenuItem value="Intermediate">Intermediate</MenuItem>
              <MenuItem value="Fluent">Fluent</MenuItem>
              <MenuItem value="Native">Native</MenuItem>
            </TextField>
          </Box>
        </Box>
      ))}

      <Button type="button" variant="outlined" onClick={handleAdd} className="candidate-add-btn">
        Add Language
      </Button>
    </Box>
  );
}
